//Models
PJQ.models.dailyReports.SurveyTemplateQuestion = PJQ.models.BaseModel.extend({
	idAttribute: 'surveyQuestionId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'template',
				value: this.get('surveyTemplateId')
			},
			{
				endpoint: 'question',
				value: this.id
			}
		]);
	}
});

PJQ.models.dailyReports.SurveyTemplateUser = PJQ.models.BaseModel.extend({
	idAttribute: 'templateUserId'
});

PJQ.models.dailyReports.SurveyItem = PJQ.models.dailyReports.SurveyTemplateQuestion.extend({
	idAttribute: 'surveyAnswerId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'survey',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		model = model ? model : {};

		// ensure that answer is never an empty string, only null or a value
		if(model.answer != null && _.size(model.answer) === 0){
			model.answer = null;
		}

		this.attachments = new PJQ.collections.dailyReports.SurveyAttachments(model.attachments);

		return model;
	},
	isValid: function () {
		return !this.get('isRequired') || _.size(this.get('answer')) > 0 || _.size(this.get('answerNote')) > 0
			|| _.size(this.attachments.models) > 0;
	}
});

PJQ.models.dailyReports.SurveyAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'survey',
				value: this.get('surveyAnswerId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

PJQ.models.dailyReports.SurveyTemplate = PJQ.models.BaseModel.extend({
	idAttribute: 'surveyTemplateId',
	endpoint: function (opts, method) {
		if (this.get('projectId') > 0 && !this.isNew() && method.toLowerCase() === "get") {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'dailyReports',
				},
				{
					endpoint: 'templates',
					value: this.id
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'dailyReports',
				},
				{
					endpoint: 'templates',
					value: this.id
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		this.questions = new PJQ.collections.dailyReports.SurveyTemplateQuestions(model.questions);
		this.users = new PJQ.collections.dailyReports.SurveyUsers(model.users);

		return model;
	},
	beforeSave: function () {
		this.set('questions', this.questions.models);
		this.set('users', this.users.models);
	},
});


//Collections
PJQ.collections.dailyReports.SurveyAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.SurveyAttachment
});

PJQ.collections.dailyReports.SurveyTemplates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyTemplate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'templates'
			}
		]);
	}
});

PJQ.collections.dailyReports.SurveyTemplateQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyItem,
	getCompletedItems: function () {
		return _.filter(this.models, function (surveyItem) {
			if (surveyItem.get('fieldType').toLowerCase() === 'bool') {
				return _.size(surveyItem.get('answer')) > 0 || _.size(surveyItem.get('answerNote')) > 0 || _.size(surveyItem.attachments) > 0;
			}
			return false;
		})
	}
});

PJQ.collections.dailyReports.SurveyItems = PJQ.collections.dailyReports.SurveyTemplateQuestions.extend({
	model: PJQ.models.dailyReports.SurveyItem,
	getCompletedItems: function () {
		return _.filter(this.models, function (surveyItem) {
			if (surveyItem.get('fieldType').toLowerCase() === 'bool') {
				return _.size(surveyItem.get('answer')) > 0 || _.size(surveyItem.get('answerNote')) > 0 || _.size(surveyItem.attachments) > 0;
			}
			return false;
		})
	}
});

PJQ.collections.dailyReports.SurveyUsers = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyTemplateUser,
});
